import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { belongsTo } from 'ember-data/relationships';

import CategoryModel from 'cio/models/category';

export default class SavedRowModel extends Model {
  @attr('string') name!: string;
  @attr() data!: any; // JSON object

  @belongsTo('category', { async: false, inverse: 'savedRow' }) category?: CategoryModel;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'saved-row': SavedRowModel;
  }
}
